import smartSolveApi from './instances/smartsolve';

const MOCKED_VALUES = {
  stepId: 'CreateDocument',
  workflowKey: 'SDC_DOCUMENT_WORKFLOW_NP_WORKFLOW',
  ContainerWorkflowKey: 'SDC_DOCUMENT_WORKFLOW',
};

export const sendBulkUpload = async ({
  clientChanges,
  // stepId,
  // containerWorkflowKey,
  // workflowKey,
}) => {
  try {
    const response = await smartSolveApi.post('/bulkupload', {
      clientChanges,
      ...MOCKED_VALUES,
    });

    return response;
  } catch (e) {
    throw new Error(`sendBulkUpload() failed: ${e}`);
  }
};
